import type { SVGProps } from 'react';
import { Page } from 'iconoir-react';

/** The one Skills glyph (Figma: document page, 1.5 stroke). Use it everywhere a skill is shown so they stay in sync. */
export function SkillIcon(props: Omit<SVGProps<SVGSVGElement>, 'strokeWidth'>) {
  return <Page aria-hidden {...props} strokeWidth={1.5} />;
}
